import { jwtDecode } from "jwt-decode";

function setAccessToken(accessToken) {
  window.localStorage.setItem("access_token", accessToken);
}
function getAccessToken() {
  return window.localStorage.getItem("access_token");
}

function setIdToken(idToken) {
  window.localStorage.setItem("id_token", idToken);
}
function getIdToken() {
  return window.localStorage.getItem("id_token");
}

function setRefreshToken(refreshToken) {
  window.localStorage.setItem("refresh_token", refreshToken);
}
const getRefreshToken = () => {
  return window.localStorage.getItem("refresh_token");
};

function wrappeUser() {
  if (getIdToken() == null || getAccessToken() == null) return null;

  let _idToken = jwtDecode(getIdToken());
  let _accessToken = jwtDecode(getAccessToken());

  if (_accessToken == null || _idToken == null) return null;

  let email = _accessToken.email
    ?.replace("adcognitoprovider_", "")
    ?.replace("cognito_", "")
    ?.replace("Cognito-login_", "");

  const user = {
    name: _idToken.given_name,
    login: _idToken["samaccountname"],
    email,
  };

  return user;
}

const handleLogin = (data) => {
  if (!data) {
    removeToken();
    window.location = "/auth";
    return;
  }

  if (data["access_token"]) {
    setAccessToken(data["access_token"]);
    setIdToken(data["access_token"]);
  }

  if (data["id_token"]) setIdToken(data["id_token"]);

  if (data["refresh_token"]) setRefreshToken(data["refresh_token"]);
};

function removeToken() {
  window.localStorage.removeItem("access_token");
  window.localStorage.removeItem("id_token");
  window.localStorage.removeItem("refresh_token");
  window.localStorage.removeItem("loggedUser");
}

function logout() {
  window.localStorage.clear();
}

const current = wrappeUser;

export {
  wrappeUser as default,
  current,
  getRefreshToken,
  getIdToken,
  getAccessToken,
  handleLogin,
  logout,
};
